const tableColors = {
  lightOrange: "#fd9933",
  lightRed: "#FADBD8",
  red: "#EC7063",
  green: "#05a357",
  lightGreen: "#82E0AA",
  darkGreen: "#186A3B",
  gray: "#D0D3D4",
  lightBlue: "#85C1E9",
  darkYellow: "#D4AC0D",
  lavendar: "#BF94BC",
  darkBlue: "#4B6C81",
  darkMajenta: "#c25071",
};

export const tableStatusColors = (value: string) => {
  switch (value) {
    case "ASSIGNED":
      return tableColors.gray;
    case "POSING":
      return tableColors.lightOrange;
    case "COMPLIED":
      return tableColors.green;
    case "NON_COMPLIED":
      return tableColors.red;
    case "DELAYED":
      return tableColors.darkYellow;
    case "DELAYED_REPORTED":
      return tableColors.lightBlue;
    case "DELAY_REPORTED":
      return tableColors.lightBlue;
    case "RE_OPENED":
      return tableColors.lightRed;
    case "APPROVED":
      return "black";
    case "PENDING_FOR_APPROVAL":
      return "black";
    case "EVENT_NOT_OCCURED":
      return tableColors.lavendar;
    case "AWAITING_APPROVAL":
      return tableColors.darkBlue;
    case "REPORTED_NON_COMPLIED":
      return tableColors.darkMajenta;
    default:
      return "black";
  }
};

// export const tableStatusStyle = (value: string) => {
//   switch (value) {
//     case "ASSIGNED":
//       return {};
//     case "POSING":
//       return {
//         background: tableColors.lightOrange,
//         position: "absolute",
//         // height: "18px",
//         // width: "18px",
//         height: "12px",
//         width: "12px",
//         borderRadius: "50%",
//         top: "18px",
//         // top: "14px",
//         // left: "6px",
//       };
//     case "COMPLIED":
//       return {
//         background: tableColors.green,
//         position: "absolute",
//         // height: "18px",
//         // width: "18px",
//         height: "12px",
//         width: "12px",
//         borderRadius: "50%",
//         top: "18px",
//         // top: "14px",
//         // left: "6px",
//       };
//     case "NON_COMPLIED":
//       return {
//         background: tableColors.red,
//         position: "absolute",
//         // height: "18px",
//         // width: "18px",
//         height: "12px",
//         width: "12px",
//         borderRadius: "50%",
//         top: "18px",
//         // top: "14px",
//         // left: "6px",
//       };
//     case "DELAYED":
//       return {
//         background: tableColors.darkYellow,
//         position: "absolute",
//         // height: "18px",
//         // width: "18px",
//         height: "12px",
//         width: "12px",
//         borderRadius: "50%",
//         top: "18px",
//         // top: "14px",
//         // left: "6px",
//       };
//     case "DELAY_REPORTED":
//     case "DELAYED_REPORTED":
//       return {
//         background: tableColors.lightBlue,
//         position: "absolute",
//         // height: "18px",
//         // width: "18px",
//         height: "12px",
//         width: "12px",
//         borderRadius: "50%",
//         top: "18px",
//         // top: "14px",
//         // left: "6px",
//       };
//     case "RE_OPENED":
//       return {
//         background: tableColors.lightRed,
//         position: "absolute",
//         // height: "18px",
//         // width: "18px",
//         height: "12px",
//         width: "12px",
//         borderRadius: "50%",
//         top: "18px",
//         // top: "14px",
//         // left: "6px",
//       };
//     case "APPROVED":
//       return {};
//     case "PENDING_FOR_APPROVAL":
//       return {};
//     default:
//       return {};
//   }
// };

export const tableStatusStyle = (value: string) => {
  switch (value) {
    // case "ASSIGNED":
    //   return {};
    case "POSING":
      return {
        background: tableColors.lightOrange,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
    case "COMPLIED":
      return {
        background: tableColors.green,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
    case "NON_COMPLIED":
      return {
        background: tableColors.red,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
    case "DELAYED":
      return {
        background: tableColors.darkYellow,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
    case "DELAY_REPORTED":
    case "DELAYED_REPORTED":
      return {
        background: tableColors.lightBlue,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
    case "RE_OPENED":
      return {
        background: tableColors.lightRed,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
    // case "APPROVED":
    //   return {};
    // case "PENDING_FOR_APPROVAL":
    //   return {};
    case "EVENT_NOT_OCCURED":
      return {
        background: tableColors.lavendar,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };

    case "AWAITING_APPROVAL":
      return {
        background: tableColors.darkBlue,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
    case "REPORTED_NON_COMPLIED":
      return {
        background: tableColors.darkMajenta,
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
    default:
      return {
        background: "#DADCE0",
        position: "absolute",
        // height: "18px",
        // width: "18px",
        height: "12px",
        width: "12px",
        borderRadius: "50%",
        top: "18px",
        // top: "14px",
        // left: "6px",
      };
  }
};
export const tableScoreColors = (value: any) => {
  if (value === 0) {
    return "#e9eaec";
  } else if (value < 0) {
    return "#e9eaec";
  } else if (value < 90) {
    return "#ff5e5e";
  } else if (value > 94) {
    return "#77d577";
  } else if (value >= 90 && value <= 94) {
    return "#ffbc81";
  } else {
    return "transparent";
  }
  // if (value < 90) {
  //   return "#ff5e5e";
  // } else if (value > 94) {
  //   return "#77d577";
  // } else if (value > 89 && value < 95) {
  //   return "#ffbc81";
  // } else {
  //   return "transparent";
  // }
  //   switch (value) {
  //     case value < 90:
  //       return "red";
  //     case value > 94:
  //       return "green";
  //     case value > 89 && value < 95:
  //       return "orange";
  //     default:
  //       return "transparent";
  //   }
};
